// extracted by mini-css-extract-plugin
export default {"headerSection":"headerSection__lHJYsf"};